import React, { useState } from 'react'
import { Loader } from 'semantic-ui-react'

import * as styles from './iframe_loader.module.sass' // eslint-disable-line no-restricted-imports

const IframeLoader = (props) => {
  const [loading, setLoading] = useState(true)

  return (
    <div className={styles.wrapper}>
      {loading ? (
        <Loader active inline="centered" className={styles.spinner}>
          Loading
        </Loader>
      ) : null}
      <iframe
        src={props.src}
        title={props.title}
        width={props.width}
        height={props.height}
        type="text/html"
        frameBorder="0"
        // eslint-disable-next-line react/no-unknown-property
        allowTransparency="true"
        style={{ border: 0, opacity: loading ? 0 : 1 }}
        onLoad={() => setLoading(false)}
        className={styles.iframe}
      />
    </div>
  )
}

export { IframeLoader }
